import React, { ReactNode } from 'react';

export default function Header({ children }: { children: ReactNode | ReactNode[] }) {
  return <div className="t-card__header">{children}</div>;
}
